import { createAction, props } from '@ngrx/store';

export const enum PreviousRouteActionTypes {
  changeRoute = '[previousRoute] CHANGE_ROUTE',
}
export const changeRoute = createAction(
  PreviousRouteActionTypes.changeRoute,
  props<{ url: string }>(),
)
